import React from "react";
import {
  ScreenFlow,
  RecruitmentSteps,
} from "../../components";

const flowarray = [
  { title: "Home", link: "/" },
  { title: "Find Trials", link: "/#find_trial" },
  {
    title: "Search Results",
    link: `/results?q=NCT04144348&in=UNITED%20STATES`,
  },
  {
    title: "Trial Details",
    link: `/study/NCT04144348`,
  },
];

class NCT04144348 extends React.Component {
  
  render() {
    return (
      <div>
        {this.props.location &&
        this.props.location.search &&
        this.props.location.search.indexOf("embed=true") !== -1 ? null : (
          <>
            <RecruitmentSteps step={"Review Trials"} />
            <div className="container d-flex align-items-center justify-content-start">
              <ScreenFlow flow={flowarray} />
            </div>
          </>
        )}
        <div className="container">
          <iframe style={{height:2900,width:'100%',border:'none'}} title="NCT04144348" src="https://connect.trialscope.com/studies/801b8ffa-a52f-4e9f-a8bb-7659362fc3fe?embed=1"></iframe>
        </div>
      </div>
    );
  }
}

export default NCT04144348;
